import { View } from "@react-pdf/renderer";
import { ResumePDFHighlightableText, ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateEightEnhancedSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateEightEnhancedSection themeColor={themeColor} heading={heading} textColor="white">
      <View>
        {summary && (
          (enableHighlight || enableMistakeHighlight) ? (
            <ResumePDFHighlightableText
              text={summary}
              section="profile"
              itemIndex={null}
              style={{ color: "white" }}
              enableMistakeHighlight={enableMistakeHighlight}
            />
          ) : (
            <ResumePDFText themeColor="white">{summary}</ResumePDFText>
          )
        )}
      </View>
    </TemplateEightEnhancedSection>
  );
};
